class AnchorNav {
    constructor() {
        this.anchorNavWrapper = document.querySelector('.anchor-nav-wrapper');
        this.specialOffer = document.querySelector('.special-offer');
    }

    init() {
        this.initAnchorNav();
    }

    initAnchorNav() {
        let anchorNav = document.querySelectorAll('.anchor-nav-item a');

        anchorNav.forEach((item) => {
            item.addEventListener('click', (event) => {
                const { hash } = event.currentTarget;
                const target = document.getElementById(hash.slice(1));

                if (!target) {
                    return;
                }

                event.preventDefault();
                window.history.pushState(null, '', hash);

                // Move focus so the next Tab continues from the section, not the nav.
                if (!target.hasAttribute('tabindex')) {
                    target.setAttribute('tabindex', '-1');
                }

                target.focus({ preventScroll: true });
                target.scrollIntoView({ behavior: 'smooth' });
            });
        });

        if (this.anchorNavWrapper !== null) {
            window.addEventListener('scroll', () => this.updateStuckState());
        }
    }

    updateStuckState() {
        // sticky-offset.js keeps top at the header's height.
        const stickyTop = parseFloat(this.anchorNavWrapper.style.top) || 0;
        const isStuck = window.scrollY > 0 && this.anchorNavWrapper.getBoundingClientRect().top <= stickyTop + 1;

        this.anchorNavWrapper.classList.toggle('sticky', isStuck);

        if (isStuck && this.specialOffer !== null && window.innerWidth > 992) {
            const offset = stickyTop + this.anchorNavWrapper.offsetHeight + 20;
            this.specialOffer.style.top = `${offset}px`;
        }
    }
}

export default AnchorNav;

(() => {
    const anchorNav = new AnchorNav();
    anchorNav.init();
})();